import { MainPlayer } from '@stores/krpPlayerStores';

const tipId = (id: string) => `${id}_tip`;

export function krpShowTip({ id, text }: { id: string; text: string }) {
  const player = MainPlayer.get();
  if (!player) return;
  const spot = player.getHotspotById(id);
  if (!spot) return;
  const { ath, atv, zOrder } = spot;
  player.addTextHotspot({
    id: tipId(id),
    text,
    ath,
    atv,
    ox: 0,
    oy: -20,
    edge: 'bottom',
    padding: '5 10',
    align: 'center',
    zOrder,
    font: {
      fontSize: 14,
      fontColor: '#ffffff',
    },
    background: {
      bgColor: '#000000',
      bgAlpha: 0.5,
      bgRoundedge: 5,
      borderWidth: 0,
      borderColor: '0,0,0,0.5',
    },
  });
}

export function krpHideTip({ id }: { id: string }) {
  const player = MainPlayer.get();
  if (!player) return;
  player.removeHotspotById(tipId(id));
}
